import * as angular from 'angular';
import {IController} from "angular";
import {FulfillmentStepDisplayStatusType} from "../../types/fulfillment-step-display-status.type";
import * as _ from "lodash";

export class FulfillmentStepStatusMultiSelectListComponent implements IController {
  fulfillmentStepDisplayStatus: any;
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  private selectedKeys: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    if (!this.options || !this.options.length) {
      this.options = angular.copy(Object.values(FulfillmentStepDisplayStatusType));
    }
  }

  $onChanges(changes) {
    if (changes.fulfillmentStepDisplayStatus) {
      this.selectedKeys = [];
      _.forEach(this.fulfillmentStepDisplayStatus, (type) => {
        this.selectedKeys[type] = true;
      })
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  onToggle(option, isSelected) {
    this.onChange({
      fulfillmentStepDisplayStatus: isSelected ? _.concat(this.fulfillmentStepDisplayStatus, [option]) :
        _.filter(this.fulfillmentStepDisplayStatus, (type) => {
          return type !== option;
        })
    });
  }

  onReset() {
    this.onChange({fulfillmentStepDisplayStatus: []});
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentStepStatusMultiSelectList', {
    bindings: {
      fulfillmentStepDisplayStatus: '<',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./fulfillment-step-status-multi-select-list.html').default,
    controller: FulfillmentStepStatusMultiSelectListComponent
  });


